import { Injectable } from '@angular/core';
import { Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable()
export class MetaTagsService extends Meta {

  /**
   * Default meta tags
   */
  static readonly defaultMetaTags: MetaDefinition[] = [
    { name: 'og:title', content: 'შენი იდეა ქალაქის მერს' },
    { name: 'og:description', content: 'ჩაერთე ქალაქის განვითარებაში, მიმართე იდეით მერს!' },
    { name: 'og:image', content: 'http://example.com/fallback-image.png' }
  ];

  /**
   * Updates meta tags
   *
   * @param tags
   */
  updateTags(tags: MetaDefinition[]) {
    tags.forEach((tag) => this.updateTag(tag));
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/meta-tags.service.ts